export default __webpack_public_path__ + "static/avatar-6aef9a069fbeb9aa6e72114966531502.jpg";